<template lang="pug">
.checkbox-option(@click='toggle' :style="{ cursor: desabilitado ? 'not-allowed' : 'pointer' }")
    input.checkbox-option-value(:id='id', :value='id', :checked='selecionado', type='checkbox' :disabled='desabilitado')
    .checkmark.mdi.mdi-checkbox-marked-outline(v-if='selecionado' :style="{ opacity: desabilitado ? '0.5' : '1' }")
    .checkmark.mdi.mdi-checkbox-blank-outline(v-else)
    .checkbox-option-label(v-if='label') {{ label }}
</template>

<script>
export default {
    name: 'CheckboxInputComponent',
    props: {
        id: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
        },
        selecionado: {
            type: Boolean,
            default: false,
        },
        desabilitado: {
            type: Boolean,
            default: false,
        },
        item: {
            type: Object,
            default: false,
            default: () => ({
                selecionado: false,
            }),
        },
    },
    methods: {
        toggle() {
            if (!this.desabilitado) {
                this.$emit('change', this.value);
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/styles/variaveis.scss';

.checkbox-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 5px 0 5px 0;
}

input[type='checkbox'].checkbox-option-value {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark {
    height: 21px;
    width: 21px;
    background-color: $success-color-light;
}

.checkbox-option:hover input[type='checkbox']~.checkmark {
    background-color: $success-color-light;
}

.checkbox-option input[type='checkbox']:checked~.checkmark {
    background-color: $primary-color;
}

.checkmark:after {
    content: '';
    position: absolute;
    display: none;
}

.checkbox-option input[type='checkbox']:checked~.checkmark:after {
    display: block;
}

.checkbox-option-label {
    margin-left: 10px;
}
</style>
